import React, { useEffect, useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { Tab, Tabs } from "@mui/material";
import { FormStep, TextInput, CardLabel, RadioButtons, CheckBox, LinkButton, Loader, Toast, SearchIcon, DeleteIcon, SubmitBar } from "@egovernments/digit-ui-react-components";
import { stringReplaceAll, getPattern, convertDateTimeToEpoch, convertDateToEpoch } from "../../utils";
import Timeline from "../../components/Timeline";
import TabPanel from "../TabPanel";


const OwnerDetails = ({ t, onSelect, formData, currStep }) => {
  let validation = {};
  sessionStorage.removeItem("currentPincode");
  const flow = Digit?.SessionStorage.get("CITIZEN.COMMON.HOME.FLOW");
  const isUD = flow === "UD";
  let isedittrade = window.location.href.includes("edit-application");
  let isrenewtrade = window.location.href.includes("renew-trade");
  const [currentTab, setCurrentTab] = useState("1");
  const tenantId = formData?.landAreaDetails?.tenantId || Digit.ULBService.getCurrentTenantId();
  const stateId = Digit.ULBService.getStateId();
  const localName = formData?.landAreaDetails?.locality?.localname?.trim()
  const [canmovenext, setCanmovenext] = useState(isedittrade || isrenewtrade ? false : true);
  const [ownershipCategoryList, setOwnershipCategoryList] = useState([]);
  const [genderList, setGenderList] = useState([]);
  const [ownershipCategory, setOwnershipCategory] = useState(formData.landInfo?.owners?.ownershipCategory);
  const [name, setName] = useState(formData.landInfo?.owners?.name || "");
  const [guardiaNname, setguardianName] = useState(formData.landInfo?.owners?.fatherOrHusbandName || formData.landInfo?.owners?.guardianName || "");
  const [emailId, setemailId] = useState(formData.landInfo?.owners?.emailId || "");
  const [aadharNo, setaadharNo] = useState(formData.landInfo?.owners?.aadharNo || "");
  const [isPrimaryOwner, setisPrimaryOwner] = useState(false);
  const [gender, setGender] = useState(formData.landInfo?.owners?.gender);
  const [mobileNumber, setMobileNumber] = useState(formData.landInfo?.owners?.mobileNumber || "");
  const [corAddress, setCorAddress] = useState(formData.landInfo?.owners?.corrAddress || "")
  const [permAddress, setPermAddress] = useState(formData.landInfo?.owners?.permAddress || "")
  const [corState, setCorState] = useState(formData.landInfo?.owners?.corrState || "")
  const [permState, setPermState] = useState(formData.landInfo?.owners?.permState || "")
  const [corDistrict, setCorDistrict] = useState(formData.landInfo?.owners?.corrDistrict || "")
  const [permDistrict, setPermDistrict] = useState(formData.landInfo?.owners?.permDistrict || "")
  const [corTehsil, setCorTehsil] = useState(formData.landInfo?.owners?.corrTehsil || "")
  const [permTehsil, setPermTehsil] = useState(formData.landInfo?.owners?.permTehsil || "")
  const [corTown, setCorTown] = useState(formData.landInfo?.owners?.corrTown || "")
  const [permTown, setPermTown] = useState(formData.landInfo?.owners?.permTown || "")
  const [corPinNo, setCorPinNo] = useState(formData.landInfo?.owners?.corrPinNo || "")
  const [permPinNo, setPermPinNo] = useState(formData.landInfo?.owners?.permPinNo || "")
  const [disable, setDisable] = useState(true)
  const [showToast, setShowToast] = useState(null);
  const [isDisable, setIsDisable] = useState(false);
  let Webview = !Digit.Utils.browser.isMobile();
  const ismultiple = ownershipCategory?.code.includes("MULTIPLEOWNERS") ? true : false;
  formData.landInfo?.owners?.forEach(owner => {
    if (owner.isPrimaryOwner == "false") owner.isPrimaryOwner = false
  })
  const [fields, setFeilds] = useState(
    formData.landInfo?.owners || [{
      isPrimaryOwner: true,
      mobileNumber: null,
      name: "",
      guardianName: "",
      fatherOrHusbandName: "",
      emailId: "",
      aadhaarNumber: ""
    }]
  );
  const [addressfields, setAddressFeilds] = useState(
    formData.landInfo?.permanentaddress || [{
      address: "",
      state: "",
      district: "",
      tehsil: "",
      town: "",
      pinno: "",
    }]
  );
  const [corraddressfields, setCorAddressFeilds] = useState(
    formData.landInfo?.correspondanceaddress || [{
      address: "",
      state: "",
      district: "",
      tehsil: "",
      town: "",
      pinno: "",
    }]
  );
  const [isPermanentSameAsCorrespondence, setIsPermanentSameAsCorrespondence] = useState(false);

  useEffect(() => {
    var flag = 0;
    fields.map((ob) => {
      if (ob.isPrimaryOwner)
        flag = 1;
      if (ob.name && ob.mobileNumber) {
        setCanmovenext(false);
      }
      else {
        setCanmovenext(true);
      }
    })
    if (!canmovenext && ownershipCategory && !(ownershipCategory?.code.includes("SINGLEOWNER"))) {
      if (flag == 1)
        setCanmovenext(false);
      else
        setCanmovenext(true);
    }
  }, [fields])

  useEffect(() => {
    const values = cloneDeep(fields);
    if (ownershipCategory && !ismultiple && values?.length > 1) setFeilds([{ ...values[0], isPrimaryOwner: true }]);
  }, [ownershipCategory])

  const { isLoading, data: ownerShipCategories } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["OwnerShipCategory"]);
  const { data: genderTypeData } = Digit.Hooks.obps.useMDMS(stateId, "common-masters", ["GenderType"]);

  useEffect(() => {
    const ownershipCategoryLists = ownerShipCategories?.["common-masters"]?.OwnerShipCategory;
    if (ownershipCategoryLists && ownershipCategoryLists?.length > 0) {
      const finalOwnershipCategoryList = ownershipCategoryLists.filter(data => data?.code?.includes("INDIVIDUAL"));
      finalOwnershipCategoryList.forEach(data => {
        data.i18nKey = `COMMON_MASTERS_OWNERSHIPCATEGORY_${stringReplaceAll(data?.code, ".", "_")}`
      });
      setOwnershipCategoryList(finalOwnershipCategoryList);
    }
  }, [ownerShipCategories]);

  useEffect(() => {
    const gendeTypeMenu = genderTypeData?.["common-masters"]?.GenderType || [];
    if (gendeTypeMenu && gendeTypeMenu?.length > 0) {
      const genderFilterTypeMenu = gendeTypeMenu.filter(data => data.active);
      genderFilterTypeMenu.forEach(data => {
        data.i18nKey = `COMMON_GENDER_${data.code}`;
      });
      setGenderList(genderFilterTypeMenu)
    }
  }, [genderTypeData]);

  function selectedValue(value) {
    setOwnershipCategory(value);
  }

  function handleAdd() {
    const values = [...fields];
    values.push({ name: "", gender: "", mobileNumber: null, isPrimaryOwner: false });
    setFeilds(values);
    setCanmovenext(true);
  }

  function handleRemove(index) {
    const values = [...fields];
    if (values.length != 1) {
      values.splice(index, 1);
      if (values.length == 1) {
        values[0] = { ...values[0], isPrimaryOwner: true }
      }
      setFeilds(values);
    }
  }

  function setOwnerName(i, e) {
    let units = [...fields];
    units[i].name = e.target.value;
    setName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }

  function setGuardianName(i, e) {
    let units = [...fields];
    units[i].guardianName = e.target.value;
    units[i].fatherOrHusbandName = e.target.value;
    setguardianName(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectEmail(i, e) {
    let units = [...fields];
    units[i].emailId = e.target.value;
    setemailId(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function selectAadhar(i, e) {
    let units = [...fields];
    units[i].aadhaarNumber = e.target.value;
    setaadharNo(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  const togglePermanentSameAsCorrespondence = () => {
    setIsPermanentSameAsCorrespondence(!isPermanentSameAsCorrespondence);
    if (!isPermanentSameAsCorrespondence) {
      setAddressFeilds(corraddressfields);
    } else {
      setAddressFeilds([{ address: "", state: "", district: "", tehsil: "", town: "", pinno: "" }]);
    }
  };


  function setMobileNo(i, e) {
    let units = [...fields];
    units[i].mobileNumber = e.target.value;
    setMobileNumber(e.target.value);
    setFeilds(units);
    if (units[i].gender && units[i].mobileNumber && units[i].name) {
      setCanmovenext(false);
    }
  }
  function setPrimaryOwner(i, e) {
    let units = [...fields];
    units.map((units) => {
      units.isPrimaryOwner = false;
    });
    units[i].isPrimaryOwner = ismultiple ? e.target.checked : true;
    setisPrimaryOwner(e.target.checked);
    setFeilds(units);
  }
  const [error, setError] = useState(null);
  function setCorrAddress(i, e) {
    let units = [...corraddressfields];
    units[i].address = e.target.value;
    setCorAddress(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermAddress(i, e) {
    let units = [...addressfields];
    units[i].address = e.target.value;
    setPermAddress(e.target.value);
    setAddressFeilds(units);
  }

  function selectCorrState(i, e) {
    let units = [...corraddressfields];
    units[i].state = e.target.value;
    setCorState(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermState(i, e) {
    let units = [...addressfields];
    units[i].state = e.target.value;
    setPermState(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrDistrict(i, e) {
    let units = [...corraddressfields];
    units[i].district = e.target.value;
    setCorDistrict(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermDistrict(i, e) {
    let units = [...addressfields];
    units[i].district = e.target.value;
    setPermDistrict(e.target.value);
    setAddressFeilds(units);
  }
  function selectCorrTehsil(i, e) {
    let units = [...corraddressfields];
    units[i].tehsil = e.target.value;
    setCorTehsil(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTehsil(i, e) {
    let units = [...addressfields];
    units[i].tehsil = e.target.value;
    setPermTehsil(e.target.value);
    setAddressFeilds(units);
  }

  function selectCorrTown(i, e) {
    let units = [...corraddressfields];
    units[i].town = e.target.value;
    setCorTown(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermTown(i, e) {
    let units = [...addressfields];
    units[i].town = e.target.value;
    setPermTown(e.target.value);
    setAddressFeilds(units);
  }

  function selectCorrPinNO(i, e) {
    let units = [...corraddressfields];
    units[i].pinno = e.target.value;
    setCorPinNo(e.target.value);
    setCorAddressFeilds(units);
  }
  function selectPermPinNO(i, e) {
    let units = [...addressfields];
    units[i].pinno = e.target.value;
    setPermPinNo(e.target.value);
    setAddressFeilds(units);
  }

  function getusageCategoryAPI(arr) {
    let usageCat = ""
    arr.map((ob, i) => {
      usageCat = usageCat + (i !== 0 ? "," : "") + ob.code;
    });
    return usageCat;
  }

  function getUnitsForAPI(subOccupancyData) {
    const ob = subOccupancyData?.subOccupancy;
    const blocksDetails = subOccupancyData?.data?.edcrDetails?.planDetail?.blocks || [];
    let units = [];
    if (ob) {
      let result = Object.entries(ob);
      result.map((unit, index) => {
        if (unit[0] !== "checklistData") {
          units.push({
            blockIndex: index,
            floorNo: unit[0].split("_")[1],
            unitType: "Block",
            occupancyType: blocksDetails?.[index]?.building?.occupancies?.[0]?.typeHelper?.type?.code || "A",
            usageCategory: getusageCategoryAPI(unit[1]),
          });
        }
      })
    }
    return units;
  }

  /*
  function getBlockIds(arr) {
    let blockId = {};
    arr.map((ob, ind) => {
      blockId[`Block_${ob.floorNo}`] = ob.id;
    });
    return blockId;
  }
  */

  const closeToast = () => {
    setShowToast(null);
  };

  const getOwnerDetails = async (indexValue, eData) => {
    const ownersCopy = cloneDeep(fields);
    const ownerNo = ownersCopy?.[indexValue]?.mobileNumber || "";
    setShowToast(null);

    if (!ownerNo.match(getPattern("MobileNo"))) {
      setShowToast({ key: "true", error: true, message: "ERR_MOBILE_NUMBER_INCORRECT" });
      return;
    }

    if (ownerNo === ownersCopy?.[indexValue]?.userName) {
      setShowToast({ key: "true", error: true, message: "ERR_OWNER_ALREADY_ADDED_TOGGLE_MSG" });
      return;
    }

    const matchingOwnerIndex = ownersCopy.findIndex(item => item.userName === ownerNo);

    if (matchingOwnerIndex > -1) {
      setShowToast({ key: "true", error: true, message: "ERR_OWNER_ALREADY_ADDED" });
      return;
    } else {
      const usersResponse = await Digit.UserService.userSearch(Digit.ULBService.getStateId(), { userName: fields?.[indexValue]?.mobileNumber }, {});
      if (usersResponse?.user?.length === 0) {
        setShowToast({ key: "true", warning: true, message: "ERR_MOBILE_NUMBER_NOT_REGISTERED" });
        setDisable(true)
        return;
      } else {
        const userData = usersResponse?.user?.[0];
        userData.gender = userData.gender ? { code: userData.gender, active: true, i18nKey: `COMMON_GENDER_${userData.gender}` } : "";
        if (userData?.dob) userData.dob = convertDateToEpoch(userData?.dob);
        if (userData?.createdDate) {
          userData.createdDate = convertDateTimeToEpoch(userData?.createdDate);
          userData.lastModifiedDate = convertDateTimeToEpoch(userData?.lastModifiedDate);
          userData.pwdExpiryDate = convertDateTimeToEpoch(userData?.pwdExpiryDate);
        }
        setDisable(false)
        let values = [...ownersCopy];
        if (values[indexValue]) {
          values[indexValue] = userData;
          values[indexValue].isPrimaryOwner = fields[indexValue]?.isPrimaryOwner || false;
        }
        setFeilds(values);
        setCanmovenext(values[indexValue]?.mobileNumber && values[indexValue]?.name && values[indexValue]?.gender?.code);
      }
    }
  }

  /////////////Viresh Doc 07-11-2023//////////////
  const handleChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const goNext = () => {
    setError(null);
    if (ismultiple == true && fields.length == 1) {
      window.scrollTo(0, 0);
      setError("BPA_ERROR_MULTIPLE_OWNER");
    }

    else {
      let owner = formData.owners;
      let ownerStep = { ...owner, owners: fields, ownershipCategory: ownershipCategory, correspondanceaddress: corraddressfields, permanentaddress: addressfields };

      if (!formData?.id) {
        setIsDisable(true);
        //for owners conversion
        let conversionOwners = [];
        // let corrAddress = [];
        // let permAddress = []
        ownerStep?.owners?.map(owner => {
          conversionOwners.push({
            ...owner,
            active: owner.active,
            gender: owner.gender.code,
            tenantId: tenantId,
          })
        });
        /*
        ownerStep?.correspondanceaddress.map(corradd => {
          corrAddress.push({
            ...corradd,
            active: corradd.active,
            address: corradd.address,
            state: corradd.state,
            district: corradd.tehsil,
            town: corradd.town,
            pinno: corradd.pinno
          })
        })
        ownerStep?.permanentaddress.map(permadd => {
          permAddress.push({
            ...permadd,
            active: permadd.active,
            address: permadd.address,
            state: permadd.state,
            district: permadd.tehsil,
            town: permadd.town,
            pinno: permadd.pinno
          })
        })
        */
        let payload = { ...formData };
        if(isUD){
          payload.businessService = `BPA_UD${localName}_FORM11`.toLocaleUpperCase().trim()
        }
        if(!isUD && formData?.landAreaDetails?.areaType === "Special Area"){
          payload.businessService = "BPA_TCPBBNDA_FORM11"
        }
        if(!isUD && formData?.landAreaDetails?.areaType !== "Special Area"){
          payload.businessService = "BPA_FORM11"
        }
        // payload.businessService = isUD ? `BPA_UD${localName}_FORM11`.toLocaleUpperCase().trim() : "BPA_FORM11";
        payload.applicationType = "FORM_11";
        payload.feeType = "ApplicationFee"
        // payload.typeofArea = formData?.data?.typeofArea || ""
        // payload.totalBuildUpArea = formData?.data?.totalBuildUpArea || ""
        // payload.plotArea = formData?.data?.plotArea || ""
        // payload.khataNo = formData?.data?.khataNo || "",
        // 	payload.khatauniNo = formData?.data?.khatauniNo || "",
        // 	payload.subdivision = formData?.data?.subdivision || " ",
        // 	payload.caserefNo = formData?.data?.caserefNo || "",
        // 	payload.noOfPlot = formData?.data?.noOfPlot || "",
        // 	payload.appliedLand = formData?.data?.appliedLand || "",
        // 	payload.propertyType = formData?.data?.propertyType || "",
        // 	payload.proposal = formData?.data?.proposal || "",
        // 	payload.constructionType = formData?.data?.constructionType || "",
        // 	payload.areaforDevelopment = formData?.data?.areaforDevelopment || ""
        const userInfo = Digit.UserService.getUser();
        const accountId = userInfo?.info?.uuid;
        payload.tenantId = tenantId;
        payload.workflow = { action: "INITIATE", assignes: [userInfo?.info?.uuid] };
        payload.accountId = accountId;
        payload.documents = null;

        // Additonal details
        // payload.additionalDetails = { GISPlaceName: formData?.address?.placeName };
        // if (formData?.data?.holdingNumber) payload.additionalDetails.holdingNo = formData?.data?.holdingNumber;
        // if (formData?.data?.registrationDetails) payload.additionalDetails.registrationDetails = formData?.data?.registrationDetails;
        // if (formData?.data?.applicationType) payload.additionalDetails.applicationType = formData?.data?.applicationType;
        // if (formData?.data?.serviceType) payload.additionalDetails.serviceType = formData?.data?.serviceType;
        //For LandInfo
        payload.landInfo = {};
        //For Address
        // payload.landInfo.address = {};
        // payload.professionaldetails = {}
        // payload.professionaldetails = formData?.["professional-information"] || {}
        // if (formData?.address?.city?.code) payload.landInfo.address.city = formData?.address?.city?.code;
        // if (formData?.address?.city) payload.landInfo.address.city = formData?.address?.city;
        // if (formData?.address?.locality?.code) payload.landInfo.address.locality = { code: formData?.address?.locality?.code };
        // if (formData?.address?.locality) payload.landInfo.address.locality = { code: "hp.tcpsolan" };
        // if (formData?.address?.pincode) payload.landInfo.address.pincode = formData?.address?.pincode;
        // if (formData?.address?.landmark) payload.landInfo.address.landmark = formData?.address?.landmark;
        // if (formData?.address?.street) payload.landInfo.address.street = formData?.address?.street;
        // if (formData?.address?.geoLocation) payload.landInfo.address.geoLocation = formData?.address?.geoLocation;
        // if (formData?.address?.village) payload.landInfo.address.village = formData?.address?.village;
        // if (formData?.address?.areaType) payload.landInfo.address.areaType = formData?.address?.areaType;

        payload.landInfo.owners = conversionOwners;
        payload.landInfo.ownershipCategory = ownershipCategory.code;
        payload.landInfo.owners[0].correspondenceAddress = ownerStep.correspondanceaddress[0];
        payload.landInfo.owners[0].permanentAddress = ownerStep.permanentaddress[0];
        payload.landInfo.ownerCorrespondanceAddress = null;
        payload.landInfo.ownerPermanentAddress = null;
        //for units
        // const blockOccupancyDetails = formData;
        // payload.landInfo.unit = getUnitsForAPI(blockOccupancyDetails);
        // payload.landInfo.checklistdata = formData?.subOccupancy?.checklistData || {}
        // let nameOfAchitect = sessionStorage.getItem("BPA_ARCHITECT_NAME");
        // let parsedArchitectName = nameOfAchitect ? JSON.parse(nameOfAchitect) : "ARCHITECT";
        // payload.additionalDetails.typeOfArchitect = parsedArchitectName;
        // create BPA call
        if (currentTab == "1") {
          setCurrentTab("2")
          return;
        }

        if (currentTab == "2") {
          setCurrentTab("3")
          return;
        }
        Digit.OBPSService.createForm11({ PermissionOfSubdivision: payload }, tenantId)
          .then((result, err) => {
            if (result?.PermissionOfSubdivision?.length > 0) {
              /*
              result?.PermissionOfSubdivision?.[0]?.landInfo?.owners?.forEach(owner => {
                owner.gender = { code: owner.gender, active: true, i18nKey: `COMMON_GENDER_${owner.gender}` }
              });
              result.PermissionOfSubdivision[0].landInfo.owners = { ...owner, owners: result?.PermissionOfSubdivision?.[0]?.landInfo?.owners, ownershipCategory };
              // result.PermissionOfSubdivision[0].address = result?.PermissionOfSubdivision?.[0]?.landInfo?.address;
              // result.PermissionOfSubdivision[0].address.city = formData.landAreaDetails.city;
              // result.PermissionOfSubdivision[0].address.locality = formData.landAreaDetails.locality;
              // // result.PermissionOfSubdivision[0].placeName = formData?.address?.placeName;
              // result.PermissionOfSubdivision[0].data = formData.data;
              // result.PermissionOfSubdivision[0].BlockIds = getBlockIds(result.PermissionOfSubdivision[0].landInfo.unit);
              // result.PermissionOfSubdivision[0].subOccupancy = formData?.subOccupancy;
              result.PermissionOfSubdivision[0].uiFlow = formData?.uiFlow || { flow: 'Form11' };
              */
              setIsDisable(false);
              onSelect("", result.PermissionOfSubdivision[0], "", true);
            }
          })
          .catch((e) => {
            setIsDisable(false);
            setShowToast({ key: "true", error: true, message: e?.response?.data?.Errors[0]?.message });
          });


      } else {
        if (currentTab == "1") {
          setCurrentTab("2")
          return;
        }
        if (currentTab == "2") {
          setCurrentTab("3")
          return;
        }

        onSelect(currStep.key, ownerStep);
      }
    }
  };

  const onSkip = () => onSelect();

  return (
    <div>
      <Timeline currentStep={currStep.step} flow="Form11" />
      <FormStep
        onSelect={goNext} onSkip={onSkip} t={t}
        isDisabled={canmovenext || !ownershipCategory || isDisable} forcedError={t(error)}
        cardStyle={{ margin: '1.25rem auto 2rem' }}>

        {!isLoading ?
          <div style={{ marginBottom: "10px" }}>
            <Tabs value={currentTab} onChange={handleChange}>
              {currStep.tabList.map((tab, index) => (
                <Tab label={`${t(tab)}`} value={`${index + 1}`} sx={{ textTransform: 'none', p: '0 1rem !important' }} />
              ))}
            </Tabs>
            <TabPanel value={currentTab} index="1" sx={{ p: 0 }}>
              <CardLabel>{`${t("BPA_TYPE_OF_OWNER_LABEL")} *`}</CardLabel>
              <RadioButtons
                isMandatory={false}
                options={ownershipCategoryList}
                selectedOption={ownershipCategory}
                optionsKey="i18nKey"
                onSelect={selectedValue}
                value={ownershipCategory}
                labelKey="PT_OWNERSHIP"
                isDependent={true}
              />

              {fields.map((field, index) => {
                return (
                  <div key={`${field}-${index}`}>
                    <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                      <CardLabel style={{ marginBottom: "-15px" }}>{`${t("CORE_COMMON_MOBILE_NUMBER")} *` + `${t("(Please click on search icon to check wheather the owner registered or not)")}`}</CardLabel>
                      {ismultiple && <LinkButton
                        label={<DeleteIcon style={{ float: "right", position: "relative", bottom: "5px" }} fill={!(fields.length == 1) ? "#494848" : "#FAFAFA"} />}
                        style={{ width: "100px", display: "inline", background: "black" }}
                        onClick={(e) => handleRemove(index)}
                      />}
                      <div style={{ marginTop: "30px" }}>
                        <div className="field-container">
                          <div style={{ position: "relative", zIndex: "100", left: "35px", marginTop: "-24.5px", marginLeft: Webview ? "-25px" : "-25px" }}>+91</div>
                          <TextInput
                            style={{ background: "#FAFAFA", padding: "0px 35px" }}
                            type={"text"}
                            t={t}
                            isMandatory={false}
                            optionKey="i18nKey"
                            name="mobileNumber"
                            value={field.mobileNumber}
                            onChange={(e) => setMobileNo(index, e)}
                            {...(validation = {
                              isRequired: true,
                              pattern: "[6-9]{1}[0-9]{9}",
                              type: "tel",
                              title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                            })}
                          />
                          <div style={{ position: "relative", zIndex: "100", right: "35px", marginTop: "-24px", marginRight: Webview ? "-20px" : "-20px" }} onClick={(e) => getOwnerDetails(index, e)}> <SearchIcon /> </div>
                        </div>
                      </div>
                      <CardLabel>{`${t("CORE_COMMON_NAME")} *`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="name"
                        value={field.name}
                        onChange={(e) => setOwnerName(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />
                      <CardLabel>{`${t("CORE_COMMON_GUARDIAN_NAME")} *`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="guardianName"
                        value={field.guardianName}
                        onChange={(e) => setGuardianName(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />
                      <CardLabel>{t("BPA_APPLICANT_EMAIL_LABEL") + "*"}</CardLabel>
                      <TextInput
                        t={t}
                        type={"email"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="emailId"
                        value={field.emailId}
                        onChange={(e) => selectEmail(index, e)}
                        //disable={editScreen}
                        {...{ required: true, pattern: "[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$", type: "email", title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID") }}
                      />
                      <CardLabel>{t("BPA_APPLICANT_AADHAR_NO_LABEL")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"number"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="aadhaarNumber"
                        value={field.aadhaarNumber}
                        onChange={(e) => selectAadhar(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: getPattern("AadharNo"),
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />

                      {ismultiple && (
                        <CheckBox
                          label={t("BPA_IS_PRIMARY_OWNER_LABEL")}
                          onChange={(e) => setPrimaryOwner(index, e)}
                          value={field.isPrimaryOwner}
                          checked={field.isPrimaryOwner}
                          style={{ paddingTop: "10px" }}
                        />
                      )}
                    </div>
                  </div>
                );
              })}

            </TabPanel>
            <TabPanel value={currentTab} index="2" sx={{ p: 0 }}>
              {corraddressfields.map((field, index) => {
                return (
                  <div key={`${field}-${index}`}>
                    <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                      <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="corrAddress"
                        value={field.address}
                        onChange={(e) => setCorrAddress(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />
                      <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="corrstate"
                        value={field.state}
                        onChange={(e) => selectCorrState(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />

                      <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="district"
                        value={field.district}
                        onChange={(e) => selectCorrDistrict(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />

                      <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="tehsil"
                        value={field.tehsil}
                        onChange={(e) => selectCorrTehsil(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="town"
                        value={field.town}
                        onChange={(e) => selectCorrTown(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="pinno"
                        value={field.pinno}
                        onChange={(e) => selectCorrPinNO(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                    </div>
                  </div>
                );
              })}

            </TabPanel>
            <TabPanel value={currentTab} index="3" sx={{ p: 0 }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isPermanentSameAsCorrespondence}
                    onChange={togglePermanentSameAsCorrespondence}
                    color="primary" // You can change the color to 'default' or 'secondary'
                  />
                }
                label="Is Same as Correspondence Address?"
              />

              {addressfields.map((field, index) => {
                return (
                  <div key={`${field}-${index}`}>
                    <div style={{ border: "solid", borderRadius: "5px", padding: "20px 20px 0", marginTop: "10px", borderColor: "#f3f3f3", background: "#FAFAFA" }}>
                      <CardLabel>{`${t("CORE_COMMON_ADDRESS")}`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="corrAddress"
                        value={field.address}
                        onChange={(e) => selectPermAddress(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />
                      <CardLabel>{`${t("CORE_COMMON_STATE")}`}</CardLabel>
                      <TextInput
                        style={{ background: "#FAFAFA" }}
                        t={t}
                        type={"text"}
                        isMandatory={false}
                        optionKey="i18nKey"
                        name="corrstate"
                        value={field.state}
                        onChange={(e) => selectPermState(index, e)}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          type: "text",
                          title: t("TL_NAME_ERROR_MESSAGE"),
                        })}
                      />

                      <CardLabel>{t("CORE_COMMON_DISTRICT")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="district"
                        value={field.district}
                        onChange={(e) => selectPermDistrict(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />

                      <CardLabel>{t("CORE_COMMON_TEHSIL")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="tehsil"
                        value={field.tehsil}
                        onChange={(e) => selectPermTehsil(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <CardLabel>{t("CORE_COMMON_TOWN")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="town"
                        value={field.town}
                        onChange={(e) => selectPermTown(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                      <CardLabel>{t("CORE_COMMON_PINNO")}</CardLabel>
                      <TextInput
                        t={t}
                        type={"text"}
                        isMandatory={true}
                        optionKey="i18nKey"
                        name="pinno"
                        value={field.pinno}
                        onChange={(e) => selectPermPinNO(index, e)}
                        //disable={editScreen}
                        {...(validation = {
                          isRequired: true,
                          pattern: "^[a-zA-Z-.`' ]*$",
                          title: t("CORE_COMMON_APPLICANT_MOBILE_NUMBER_INVALID"),
                        })}
                      />
                    </div>
                  </div>
                );
              })}

            </TabPanel>
            {ismultiple ? (
              <div>
                <div style={{ display: "flex", paddingBottom: "15px", color: "#FF8C00" }}>
                  <button type="button" style={{ paddingTop: "10px" }} onClick={() => handleAdd()}>
                    {t("BPA_ADD_OWNER")}
                  </button>
                </div>
              </div>
            ) : null}
          </div> : <Loader />
        }
        <SubmitBar label={t(`CS_COMMON_NEXT`)} onSubmit={goNext} disabled={disable} />

      </FormStep>
      {showToast && <Toast
        error={showToast?.error}
        warning={showToast?.warning}
        label={t(showToast?.message)}
        isDleteBtn={true}
        onClose={closeToast}
      />
      }
    </div>
  );
};

export default OwnerDetails;
